import { render, staticRenderFns } from "./WholesaleCompaniesTable.vue?vue&type=template&id=0c70eeea&"
import script from "./WholesaleCompaniesTable.vue?vue&type=script&lang=js&"
export * from "./WholesaleCompaniesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/blocks/WholesaleCompaniesTable.vue
// module id = null
// module chunks = 